/**
 * Empty Property Constant
 *
 * Used for creating new empty rental properties in the application.
 */
import { UpsellCardType, type YourRentalPropertyDto } from '@zg-rentals/ts-your-rental-api-client';

export const EMPTY_PROPERTY: YourRentalPropertyDto = {
  leaseSection: {
    upsellCardType: UpsellCardType.LEASE_UPSELL,
    leases: [],
  },
  propertyConditionSection: {
    upsellCardType: UpsellCardType.PCR_UPSELL,
    reports: [],
  },
  paymentSection: {
    alerts: [],
    upsellCardType: UpsellCardType.RENT_PAYMENTS_AND_CREDIT_CLIMB_UPSELL,
  },
  rinsSectionDto: {
    rinsCard: undefined,
    upsellCardType: undefined,
  },
};
